import { render, staticRenderFns } from "./DocumentFields.vue?vue&type=template&id=c3c03d8a&scoped=true"
import script from "./DocumentFields.vue?vue&type=script&lang=js"
export * from "./DocumentFields.vue?vue&type=script&lang=js"
import style0 from "./DocumentFields.vue?vue&type=style&index=0&id=c3c03d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c03d8a",
  null
  
)

export default component.exports